import { render, staticRenderFns } from "./management-question-view.vue?vue&type=template&id=66706a9a&scoped=true"
import script from "./management-question-view.vue?vue&type=script&lang=js"
export * from "./management-question-view.vue?vue&type=script&lang=js"
import style0 from "./management-question-view.vue?vue&type=style&index=0&id=66706a9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66706a9a",
  null
  
)

export default component.exports